var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "一键配置",
        visible: _vm.dialogVisible,
        width: "90%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            "label-position": "left",
            "label-width": "120px",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "配置类型", prop: "checkedTypes" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择配置类型",
                    filterable: "",
                    multiple: "",
                  },
                  on: { change: _vm.onMultiConfigTypeChange },
                  model: {
                    value: _vm.ruleForm.checkedTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "checkedTypes", $$v)
                    },
                    expression: "ruleForm.checkedTypes",
                  },
                },
                _vm._l(_vm.configTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "操作", prop: "changeState" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.changeState,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "changeState", $$v)
                    },
                    expression: "ruleForm.changeState",
                  },
                },
                _vm._l(_vm.changeStateList, function (item, index) {
                  return _c(
                    "el-radio",
                    { key: index, attrs: { label: item.value } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "今日可导订单数", prop: "orders" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, label: "请输入可导订单" },
                model: {
                  value: _vm.todayOrders,
                  callback: function ($$v) {
                    _vm.todayOrders = $$v
                  },
                  expression: "todayOrders",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "item-label" }, [
                _vm._v("昨日可导订单：" + _vm._s(_vm.yesterdayOrders)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.ruleForm.checkedTypes.length > 0
            ? _c(
                "el-form-item",
                { attrs: { label: "模型比例配置" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "强导配置值", name: "content" } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                "body-style": "background: #f7f8fa",
                                shadow: "never",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "padding-bottom": "20px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-plus",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPattern("ratioList")
                                        },
                                      },
                                    },
                                    [_vm._v("添加模型和比例")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "padding-left": "20px" } },
                                    [
                                      _vm._v(
                                        "总比例：" +
                                          _vm._s(_vm.totalRatio) +
                                          "%"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.ruleForm.checkedTypes.length > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-left": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "总上限：" +
                                              _vm._s(_vm.totalLimit) +
                                              " 单"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.ratioList,
                                function (ratioItem, ratioIndex) {
                                  return _c(
                                    "el-form",
                                    {
                                      key: "content-" + ratioIndex,
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: { inline: true },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "width-200",
                                              attrs: {
                                                placeholder: "选择或填写模型",
                                                filterable: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onSelectChange(
                                                    "ratioList",
                                                    ratioIndex
                                                  )
                                                },
                                              },
                                              model: {
                                                value: ratioItem.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    ratioItem,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "ratioItem.value",
                                              },
                                            },
                                            _vm._l(
                                              _vm.patternList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "比例" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass: "width-120",
                                            attrs: {
                                              min: 0,
                                              max: 100,
                                              precision: 0,
                                              label: "比例",
                                            },
                                            on: { change: _vm.updateFans },
                                            model: {
                                              value: ratioItem.weight,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  ratioItem,
                                                  "weight",
                                                  $$v
                                                )
                                              },
                                              expression: "ratioItem.weight",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "预计加粉" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "70px" },
                                            attrs: {
                                              value: ratioItem.fans,
                                              readOnly: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !ratioItem.showLimit &&
                                      ratioItem.limit === 0
                                        ? _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openLimitConfig(
                                                        "ratioList",
                                                        ratioIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    配置上限\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-form-item",
                                            [
                                              _vm._v(
                                                "\n                                上限\n                                "
                                              ),
                                              _c("el-input-number", {
                                                staticClass: "width-120",
                                                attrs: {
                                                  min: 0,
                                                  precision: 0,
                                                  label: "比例",
                                                },
                                                model: {
                                                  value: ratioItem.limit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      ratioItem,
                                                      "limit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "ratioItem.limit",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                单\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deletePattern(
                                                    "ratioList",
                                                    ratioIndex
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    删除\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goPatternDetail(
                                                    ratioItem.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    查看配置\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showSContentTab
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: { label: "特殊配置值", name: "s_content" },
                            },
                            [
                              _c(
                                "el-card",
                                {
                                  attrs: {
                                    "body-style": "background: #f7f8fa",
                                    shadow: "never",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "padding-bottom": "20px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-plus",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addPattern(
                                                "sRatioList"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("添加模型和比例")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-left": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "总比例：" +
                                              _vm._s(_vm.sTotalRatio) +
                                              "%"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.ruleForm.checkedTypes.length > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "总上限：" +
                                                  _vm._s(_vm.sTotalLimit) +
                                                  " 单"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.sRatioList,
                                    function (ratioItem, ratioIndex) {
                                      return _c(
                                        "el-form",
                                        {
                                          key: "s_content-" + ratioIndex,
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                          attrs: { inline: true },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "width-200",
                                                  attrs: {
                                                    placeholder:
                                                      "选择或填写模型",
                                                    filterable: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onSelectChange(
                                                        "sRatioList",
                                                        ratioIndex
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: ratioItem.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        ratioItem,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "ratioItem.value",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.patternList,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "比例" } },
                                            [
                                              _c("el-input-number", {
                                                staticClass: "width-120",
                                                attrs: {
                                                  min: 0,
                                                  max: 100,
                                                  precision: 0,
                                                  label: "比例",
                                                },
                                                on: { change: _vm.updateSFans },
                                                model: {
                                                  value: ratioItem.weight,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      ratioItem,
                                                      "weight",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ratioItem.weight",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "预计加粉" } },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  value: ratioItem.fans,
                                                  readOnly: "",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !ratioItem.showLimit &&
                                          ratioItem.limit === 0
                                            ? _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openLimitConfig(
                                                            "sRatioList",
                                                            ratioIndex
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    配置上限\n                                "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "el-form-item",
                                                [
                                                  _vm._v(
                                                    "\n                                上限\n                                "
                                                  ),
                                                  _c("el-input-number", {
                                                    staticClass: "width-120",
                                                    attrs: {
                                                      min: 0,
                                                      precision: 0,
                                                      label: "比例",
                                                    },
                                                    model: {
                                                      value: ratioItem.limit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ratioItem,
                                                          "limit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ratioItem.limit",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                单\n                            "
                                                  ),
                                                ],
                                                1
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deletePattern(
                                                        "sRatioList",
                                                        ratioIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    删除\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goPatternDetail(
                                                        ratioItem.value
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    查看配置\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.showSContentTab
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-plus" },
                          on: { click: _vm.onAddSContent },
                        },
                        [
                          _vm._v(
                            "\n                添加特殊配置值\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("ruleForm")
                },
              },
            },
            [_vm._v("\n            确 定\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }